import { AssetBanksInterface } from '@app/entities/banks';

export const AssetBanks: AssetBanksInterface = {
  banks: [],
  enabled_bank_installments: [],
  special_bank_installments: [],
  min_price_banks_exception: {
    default_min_price_banks: null,
    bank_items_min_price: null,
    bank_items: [],
    bank_subtitle: ''
  }
};
